<div *ngIf="result" class="tab-pane fade active show">
  <table class="std-results-list patients-registered">
    <tbody>
      @for (patientRegistration of result.results; track patientRegistration.id) {
      <tr>
        <td class="valign-top">
          <span class="label d-none d-lg-block">Status</span>
          <span class="badge" [class.badge-success]="patientRegistration.state === 'Actioned'"
            [class.badge-warning]="patientRegistration.state === 'Pending'">{{ patientRegistration.state }}</span>
        </td>
        <td class="valign-top">
          <span class="label d-none d-lg-block">Patient Code</span>
          <span class="patient-trial-name">{{ patientRegistration.patientNumber }}</span>
        </td>
        <td class="valign-top">
          <span class="label d-none d-lg-block">Patient Name</span>
          <span class="patient-trial-name">{{ patientRegistration.patientName }}</span>
        </td>
        <td class="valign-top">
          <span class="label d-none d-lg-block">Trial Code</span>
          <span class="patient-trial-name">{{ patientRegistration.trialCode }}</span>
        </td>
        <td class="valign-top">
          <span class="label d-none d-lg-block">Site</span>
          <span class="patient-trial-name">{{ patientRegistration.siteNumber }}</span>
        </td>
        <td class="valign-top">
          <span class="label d-none d-lg-block">Created</span>
          <span class="patient-trial-name">{{ patientRegistration.created | date: 'd MMM yyyy' }} at {{
            patientRegistration.created | date: 'h:mm aaa' }}</span>
        </td>
        <td class="valign-top">
          <span class="label d-none d-lg-block">Actioned</span>
          @if (patientRegistration.actioned) {
          <span class="patient-trial-name">{{ patientRegistration.actioned | date: 'd MMM yyyy' }} at {{
            patientRegistration.actioned | date: 'h:mm aaa' }}</span>
          } @else {
          <span class="patient-trial-name">-</span>
          }
        </td>
        <td class="text-right result-btn">
          <div class="button-container">
            <app-split-button
              size="sm"
              [actions]="getActions(patientRegistration)"
              (actionSelected)="onSplitAction($event, patientRegistration)">
            </app-split-button>
          </div>
        </td>
      </tr>
      }
    </tbody>
  </table>

  <app-pagination [currentPage]="result.currentPage" [totalPageCount]="result.totalPageCount"
    (pageSelected)="loadPatientRegistrations($event, keywords, orderBy, state)"></app-pagination>

  <div class="no-results inside" *ngIf="!result.results.length">
    <div class="inner">
      <div class="image">
        <img src="assets/img/no-results-illustration.png" alt="No results found" />
      </div>
      <div class="content">
        <h2>No Results Found</h2>
        <p>There are no patients matching your search.</p>
      </div>
    </div>
  </div>

</div>

<app-confirm-action-modal #confirmRejectPatientRegistrationModal [title]="'Reject Patient Registration?'"
  [message]="'Are you sure you want to reject this patient registration?'"
  (confirmed)="onRejectConfirmed($event)"></app-confirm-action-modal>

<app-patient-add-modal></app-patient-add-modal>


<app-modal #patientRegistrationDetails customClassName="registration-details-modal">
  <div class="modal-header">
    <h2 class="modal-title">Patient Registration Details</h2>
  </div>
  <div class="modal-body" *ngIf="patientRegistration">

    <table class="simple-form">
      <tr>
        <th><label>Public Trial Code</label></th>
        <td>
          <div class="form-group">
            <input type="text" class="form-control" disabled [value]="patientRegistration.trialCode">
          </div>
        </td>
      </tr>
      <tr>
        <th><label>Site Number</label></th>
        <td>
          <div class="form-group">
            <input type="text" class="form-control" disabled [value]="patientRegistration.siteNumber">
          </div>
        </td>
      </tr>
      <tr>
        <th><label>Investigator Name</label></th>
        <td>
          <div class="form-group">
            <input type="text" class="form-control" disabled [value]="patientRegistration.investigatorName">
          </div>
        </td>
      </tr>
      <tr>
        <th><label>Contact Email (person who completed this form)</label></th>
        <td>
          <div class="form-group">
            <input type="text" class="form-control" disabled [value]="patientRegistration.formFillerEmail">
          </div>
        </td>
      </tr>
    </table>

    <h3>Patient Details</h3>
    <table class="simple-form">
      <tr>
        <th><label>Patient Name</label></th>
        <td>
          <div class="form-group">
            <input type="text" class="form-control" disabled [value]="patientRegistration.patientName">
          </div>
        </td>
      </tr>
      <tr>
        <th><label>Patient Number</label></th>
        <td>
          <div class="form-group">
            <input type="text" class="form-control" disabled [value]="patientRegistration.patientNumber">
          </div>
        </td>
      </tr>
      <tr>
        <th><label>Email Address</label></th>
        <td>
          <div class="form-group">
            <input type="text" class="form-control" disabled [value]="patientRegistration.email">
          </div>
        </td>
      </tr>
      <tr>
        <th><label>Language</label></th>
        <td>
          <div class="form-group">
            <input type="text" class="form-control" disabled [value]="patientLanguage">
          </div>
        </td>
      </tr>
      <tr>
        <th><label>Screening Date (if applicable)</label></th>
        <td>
          <div class="form-group">
            @if (patientRegistration.screeningDate) {
            <input type="text" class="form-control" disabled
              value="{{ patientRegistration.screeningDate | date: 'd MMM yyyy'}}">
            } @else {
            <input type="text" class="form-control" disabled value="">
            }
          </div>
        </td>
      </tr>
      <tr>
        <th><label>PatientGO Card Number</label></th>
        <td>
          <div class="form-group">
            <input type="text" class="form-control" disabled [value]="patientRegistration.cardNumber">
          </div>
        </td>
      </tr>
      @if (patientRegistration.comments) {
      <tr>
        <th><label>Comments</label></th>
        <td>
          <div class="form-group">
            <textarea class="form-control" disabled rows="3">{{ patientRegistration.comments }}</textarea>
          </div>
        </td>
      </tr>
      }
    </table>

    <table class="simple-form">
      <tr>
        <th><label>Documents</label></th>
        <td>
          <div class="document-list">
            @for (document of documents; track document.url) {
            <a [href]="document.url" target="_blank" class="btn btn-outline btn-slim"><i class="far fa-download"></i> {{
              document.label }}</a>
            }
          </div>
        </td>
      </tr>
    </table>

  </div>
  <div class="registration-modal-footer">
    <button (click)="patientRegistrationDetails.hide()" class="btn btn-secondary" data-dismiss="modal">Cancel</button>
    <div class="registration-modal-actions" *ngIf="patientRegistration?.state === 'Pending'">
      <button class="btn btn-outline" (click)="patientRegistrationDetails.hide(); onReject(patientRegistration.id)">Reject</button>
      <button class="btn btn-success" (click)="patientRegistrationDetails.hide(); onAcceptRegistration(patientRegistration)">Accept Registration</button>
    </div>
  </div>
</app-modal>
